// extracted by mini-css-extract-plugin
export default {"img":"BlogDetailsTopSection_img__qjmg6","pathSpan":"BlogDetailsTopSection_pathSpan__vlTkQ"};